/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class Crop extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }

  setAttributes(cropPopup, semanticName) {
    cropPopup.setAttribute('mode', 'open');
    cropPopup.setAttribute('univ-semantic-name', semanticName);
  }
}
